import { useTranslation } from 'react-i18next';
import type { InterventionTemplateResponse } from '../../../api/generated';
import { IconPlus } from '../../UI';
import { WeekEditorPanel } from '../WeekEditorPanel';
import type { DraftWeek } from '../templateDraftTypes';
import styles from '../../../pages/TreatmentPlanBuilderPage.module.css';

interface WeekEditorSectionProps {
  weeks: DraftWeek[];
  catalog: InterventionTemplateResponse[];
  strokeColor: string;
  fillColor: string;
  fieldErrors: Record<string, string>;
  clearFieldError: (path: string) => void;
  onChange: (weeks: DraftWeek[]) => void;
  onAddWeek: () => void;
}

export const WeekEditorSection = ({
  weeks,
  catalog,
  strokeColor,
  fillColor,
  fieldErrors,
  clearFieldError,
  onChange,
  onAddWeek
}: WeekEditorSectionProps) => {
  const { t } = useTranslation();

  return (
    <section className={styles.editorSection}>
      <h2 className={styles.sectionLabel}>{t('config-builder-weeks-label')}</h2>
      <WeekEditorPanel
        weeks={weeks}
        catalog={catalog}
        strokeColor={strokeColor}
        fillColor={fillColor}
        fieldErrors={fieldErrors}
        clearFieldError={clearFieldError}
        onChange={onChange}
      />
      <button className={styles.addWeekButton} onClick={onAddWeek}>
        <IconPlus width={14} height={14} /> {t('config-builder-add-week')}
      </button>
    </section>
  );
};
